import { useState } from 'react';
import { allGames } from '../../../mocks/games';
import { openRandomPlayLink, openPlayLinkByBrand } from '../../../config/playLinks';

const categories = [
  { id: 'all', label: 'All Games', icon: 'ri-gamepad-line' },
  { id: 'Slots', label: 'Slots', icon: 'ri-trophy-line' },
  { id: 'Live Casino', label: 'Live Casino', icon: 'ri-live-line' },
  { id: 'Blackjack', label: 'Blackjack', icon: 'ri-playing-card-line' },
  { id: 'Roulette', label: 'Roulette', icon: 'ri-refresh-line' },
  { id: 'Baccarat', label: 'Baccarat', icon: 'ri-vip-diamond-line' }
];

export default function GamesSection() {
  const [activeCategory, setActiveCategory] = useState('all');
  const [visibleCount, setVisibleCount] = useState(12);

  const filteredGames = activeCategory === 'all' 
    ? allGames 
    : allGames.filter(game => game.category === activeCategory);

  const displayedGames = filteredGames.slice(0, visibleCount);
  const hasMore = visibleCount < filteredGames.length;

  const handleLoadMore = () => {
    setVisibleCount(prev => prev + 12);
  };

  const handleOpenPartner = (game?: typeof allGames[0]) => {
    // 如果是 Live Casino 且有对应的 brand，跳转到该 brand 链接
    if (game?.category === 'Live Casino' && game?.provider) {
      openPlayLinkByBrand(game.provider);
    } else {
      // 否则随机跳转
      openRandomPlayLink();
    }
  };

  return (
    <section className="py-10 bg-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="md:mb-8 mb-4">
          <h2 className="md:text-3xl text-2xl font-bold text-gray-900 mb-2">Casino Games</h2>
          <p className="text-gray-600 text-md">Play thousands of free casino games right here and enjoy the best gaming winning experience.</p>
        </div>

        {/* Horizontal Tab Bar */}
        <div className="mb-8 border-b border-gray-200 overflow-x-auto">
          <div className="flex space-x-1 min-w-max">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => {
                  setActiveCategory(category.id);
                  setVisibleCount(12);
                }}
                className={`flex items-center space-x-2 px-6 py-3 font-medium text-sm whitespace-nowrap transition-colors border-b-2 ${
                  activeCategory === category.id
                    ? 'border-green-600 text-green-600'
                    : 'border-transparent text-gray-600 hover:text-gray-900 hover:border-gray-300'
                }`}
              >
                <i className={`${category.icon} text-lg`}></i>
                <span>{category.label}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Games Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 mb-8">
          {displayedGames.map((game, index) => (
            <div
              key={index}
              role="button"
              tabIndex={0}
              onClick={() => handleOpenPartner(game)}
              onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && handleOpenPartner(game)}
              className="group bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-all duration-300 cursor-pointer"
            >
              {/* Game Image */}
              <div className="relative aspect-square overflow-hidden bg-gray-100">
                <img
                  src={game.image}
                  alt={game.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                />
                
                {/* Play Button Overlay */}
                <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                  <button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleOpenPartner(game);
                    }}
                    className="bg-green-600 hover:bg-green-700 text-white font-semibold px-6 py-2 rounded-full whitespace-nowrap transition-colors"
                  >
                    Play Free
                  </button>
                </div>
              </div>

              {/* Game Info */}
              <div className="p-3">
                <h3 className="font-semibold text-sm text-gray-900 mb-1 truncate">
                  {game.name}
                </h3>
                <p className="text-xs text-gray-500 truncate">{game.provider}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Load More Button */}
        {hasMore && (
          <div className="text-center">
            <button
              onClick={handleLoadMore}
              className="bg-white border-2 border-gray-300 hover:border-green-600 text-gray-900 hover:text-green-600 font-semibold px-8 py-3 rounded-lg whitespace-nowrap transition-all"
            >
              Load More Games
            </button>
          </div>
        )}
      </div>
    </section>
  );
}